import { unreachable } from '@/std/util';

export enum MarcadorLocal {
    Produtos = 1,
    Financeiro = 2,
    ContasReceber = 3,
    ContasPagar = 4,
    Compras = 5,
    Vendas = 6,
    DocumentosFiscais = 7,
    Comissao = 8,
    LancamentoOfx = 9,
    Clientes = 10,
    Fornecedores = 11,
}

export function marcadorLocalToString(local: MarcadorLocal): string {
    switch (local) {
        case MarcadorLocal.Produtos:
            return 'Produtos';
        case MarcadorLocal.Financeiro:
            return 'Financeiro';
        case MarcadorLocal.ContasReceber:
            return 'Contas a receber';
        case MarcadorLocal.ContasPagar:
            return 'Contas a pagar';
        case MarcadorLocal.Compras:
            return 'Compras';
        case MarcadorLocal.Vendas:
            return 'Vendas';
        case MarcadorLocal.DocumentosFiscais:
            return 'Documentos fiscais';
        case MarcadorLocal.Comissao:
            return 'Comissão';
        case MarcadorLocal.LancamentoOfx:
            return 'Lançamento Ofx';
        case MarcadorLocal.Clientes:
            return 'Clientes';
        case MarcadorLocal.Fornecedores:
            return 'Fornecedores';
        default:
            unreachable(local);
    }
}
